const MeiTuan = 1001
const DouYin = 1002


const PlatformCode = {
    MeiTuan,
    DouYin
}

export default PlatformCode




// WEBPACK FOOTER //
// ./src/containers/ClubPlatform/common/ClubPlatformContanst.js